import React, { useState, useEffect } from 'react'
import axios from '../../../utils/AxiosUtil';
import { useQuery } from 'react-query';
import './add-area.less';
import EditableTable from './areaEditTable';
import { AREA_LIST_COLUMNS } from '../../../constants/areaConstants';
import { queryAxios } from '../../../components/reqAndHint'
import { Input, Spin } from 'antd';
import { useSelector } from 'react-redux'

// 地区列表
export default function ListArea(props) {
    const [dataSrc, setDataSrc] = useState();
    let uid = sessionStorage.getItem('uid');
    const langValue = useSelector(state => state.langList.value)
    useEffect(async () => {
        // console.log('List Area effect ......', props);
        if (props?.addedArea) {
            // console.log('refresh list after form submit');
            //addData提交表单成功,将新增的地区信息放到数组开头，刷新表格
            let newData = [...dataSrc];
            newData.unshift(props.addedArea);
            newData.forEach((a, i) => a['序号'] = i + 1);
            setDataSrc(newData);
        } else {
            const data = await queryAxios('/area/listByCondition', { uid })
            let dataSrc = [...data.data.data];
            dataSrc.forEach((d, i) => { d['序号'] = i + 1 });
            // console.log('dataSrc:', dataSrc)
            setDataSrc([...dataSrc])
        }

    }, [props])

    useEffect(() => {

        return () => {
            // console.log('clear');
            setDataSrc([]);
        }

    }, [])


    let areaColumns = AREA_LIST_COLUMNS;

    const { Search } = Input;

    const onSearch = async (value) => {
        // console.log('onSearch:', value);
        const data = await queryAxios('/area/listByCondition', { uid, keyword: value });
        let dataSrc = [...data.data.data];
        dataSrc.forEach((d, i) => { d['序号'] = i + 1 });
        // console.log('dataSrc:', dataSrc)
        setDataSrc([...dataSrc])
    }
    const getColumns = (col) => {
        let newCol = [...col];
        newCol.forEach(item=>{
            item.title = langValue==0?<>{item.ch_title}<br/>{item.en_title}</>:(langValue==1?item.ch_title:item.en_title)
        })
        return newCol;
    }

    return (
        <div>
            {dataSrc ?
                (
                    <div className='area-list'>
                        <div className='search-bar'>
                            <div className='title'>
                                {langValue==0?'地区列表Region list':(langValue==1?'地区列表':'Region list')}
                            </div>

                            <Search className='search'
                                placeholder={langValue==0?'输入关键词搜索Enter Keywords to Search':(langValue==1?'输入关键词搜索':'Enter Keywords to Search')} allowClear
                                onSearch={onSearch} />
                        </div>
                        <EditableTable columns={getColumns(areaColumns)} dataSource={dataSrc} />
                    </div>
                )
                : <Spin>加载中</Spin>}


        </div>
    );

}
